/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    MenuItem,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import React from 'react';
import { IFormularioDivisionesDocumentosDefectoVistaProps } from '../interfaces';

const FormularioDivisionesDocumentosDefectoVista: React.FunctionComponent<IFormularioDivisionesDocumentosDefectoVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    entidadesFormulario,
    estadoFormulario,
    divisionesDocumentosDefecto,
}) => (
    <Dialog fullWidth open={estadoFormulario} maxWidth="xs">
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id="divisionesDocumentosDefecto.agregarDivisionesDocumentosDefecto"
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Card>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={
                                    <Texto
                                        id="divisionesDocumentosDefecto.TipoMovimientoDescripcion"
                                        display="inline"
                                    />
                                }
                                name="TipoDocumentoId"
                                onChange={cambiarInfoFomulario}
                                required
                                select
                                value={divisionesDocumentosDefecto.TipoDocumentoId}
                                variant="outlined"
                            >
                                {entidadesFormulario.tiposDocumentos.filter((x) => x.Estado === 1).length === 0 ? (
                                    <MenuItem value="">
                                        <Texto id="label.sinRegistros" />
                                    </MenuItem>
                                ) : (
                                    entidadesFormulario.tiposDocumentos
                                        .filter((x) => x.Estado === 1)
                                        .map(({ TipoDocumentoDescripcion, TipoDocumentoId }) => (
                                            <MenuItem key={TipoDocumentoId} value={TipoDocumentoId}>
                                                {TipoDocumentoDescripcion}
                                            </MenuItem>
                                        ))
                                )}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={<Texto id="divisionesDocumentosDefecto.DivisionDescripcion" display="inline" />}
                                name="DivisionId"
                                onChange={cambiarInfoFomulario}
                                select
                                required
                                value={divisionesDocumentosDefecto.DivisionId}
                                variant="outlined"
                            >
                                {entidadesFormulario.divisiones.filter((x) => x.Estado === 1).length === 0 ? (
                                    <MenuItem value="">
                                        <Texto id="label.sinRegistros" />
                                    </MenuItem>
                                ) : (
                                    entidadesFormulario.divisiones
                                        .filter((x) => x.Estado === 1)
                                        .map(({ DivisionDescripcion, DivisionId }) => (
                                            <MenuItem key={DivisionId} value={DivisionId}>
                                                {DivisionDescripcion}
                                            </MenuItem>
                                        ))
                                )}
                            </TextField>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </DialogContent>
        <DialogActions>
            <div>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                            <Texto id="boton.cancelar" />
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={accionCrearEditar} color="primary" variant="contained">
                            <Texto id="boton.guardar" />
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </DialogActions>
    </Dialog>
);

export default FormularioDivisionesDocumentosDefectoVista;
